import { useEffect, useState } from 'react'
import {
  fetchCitiesByState,
  fetchHomeStoresByCity,
  fetchStates,
  selectStates,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { Headline, Select } from 'components'
import styled from '@emotion/styled'

const HomeStoreSelectorView = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`

interface HomeStoreSelectorProps {
  onHomeStoreChange?: (value: string) => void
  initialHomeStore?: string
  error?: string
}

const HomeStoreSelector = ({
  onHomeStoreChange,
  initialHomeStore,
  error,
}: HomeStoreSelectorProps) => {
  const dispatch = useAppDispatch()
  const {
    states,
    cities,
    homeStores,
    statesLoading,
    citiesLoading,
    homeStoresLoading,
  } = useAppSelector(selectStates)

  const [selectedState, setSelectedState] = useState('')
  const [selectedCity, setSelectedCity] = useState('')
  const [selectedHomeStore, setSelectedHomeStore] = useState(
    initialHomeStore || ''
  )

  useEffect(() => {
    dispatch(fetchStates())
  }, [dispatch])

  useEffect(() => {
    if (selectedState) {
      dispatch(fetchCitiesByState(selectedState))
    }
  }, [selectedState, dispatch])

  useEffect(() => {
    if (selectedCity) {
      dispatch(fetchHomeStoresByCity(selectedCity))
    }
  }, [selectedCity, dispatch])

  const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value
    setSelectedState(value)
    // Reset city and home store when state changes
    setSelectedCity('')
    setSelectedHomeStore('')
    onHomeStoreChange?.('')
  }

  const handleCityChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value
    setSelectedCity(value)
    // Reset home store when city changes
    setSelectedHomeStore('')
    onHomeStoreChange?.('')
  }

  const handleHomeStoreChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = event.target.value
    setSelectedHomeStore(value)
    onHomeStoreChange?.(value)
  }
  const emptyOption = (field: string) => {
    return {
      name: `Select a ${field}`,
      value: '',
      disabled: true,
    }
  }
  return (
    <HomeStoreSelectorView>
      <Headline>Home Store</Headline>
      <Select
        name="state"
        value={selectedState}
        onChange={handleStateChange}
        options={[
          emptyOption('state'),
          ...states.map((state) => ({ name: state, value: state })),
        ]}
        label="State"
        showLabel
        type="select"
        disabled={statesLoading === 'pending'}
      />
      <Select
        name="city"
        value={selectedCity}
        onChange={handleCityChange}
        options={[
          emptyOption('city'),
          ...cities.map((city) => ({ name: city, value: city })),
        ]}
        label="City"
        showLabel
        type="select"
        disabled={citiesLoading === 'pending' || !selectedState}
      />
      <Select
        name="home_store"
        value={selectedHomeStore}
        onChange={handleHomeStoreChange}
        options={[
          emptyOption('home store'),
          ...homeStores.map((store) => ({
            name: store[1],
            value: store[0] + '-' + store[1],
          })),
        ]}
        label="Home Store"
        showLabel
        type="select"
        disabled={homeStoresLoading === 'pending' || !selectedCity}
        error={!selectedHomeStore ? error : undefined}
      />
    </HomeStoreSelectorView>
  )
}

export default HomeStoreSelector
